import { TextField } from "@mui/material";
import { SharedFieldInputProps } from "./types";

interface NumberFieldInputProps extends SharedFieldInputProps<number | null> {
    integer?: boolean;
}

export function NumberFieldInput({
    value,
    onChange,
    error = false,
    helperText,
    autoFocus = false,
    fullWidth = true,
    size = "small",
    disabled = false,
}: NumberFieldInputProps) {
    return (
        <TextField
            type="number"
            inputMode="numeric"
            value={value ?? ""}
            onChange={(event) => {
                const rawValue = event.target.value;
                onChange(rawValue === "" ? null : Number(rawValue));
            }}
            error={error}
            helperText={helperText}
            autoFocus={autoFocus}
            fullWidth={fullWidth}
            size={size}
            disabled={disabled}
        />
    );
}
